import { render, staticRenderFns } from "./No-Data.vue?vue&type=template&id=2efcd952&"
import script from "./No-Data.vue?vue&type=script&lang=ts&"
export * from "./No-Data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports